var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dashboard',{attrs:{"show-drawer":false},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('router-view',{on:{"alert":function($event){return _vm.bubbleAlert($event)}}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }